import React from 'react';
import styled from 'styled-components';
import { Modal } from 'antd';
import { iconClose } from 'assets/icons';

const AppModalStyled = styled(Modal)`
	.ant-modal-content {
		border-radius: 8px;
		overflow: hidden;

		.ant-modal-close {
			.ant-modal-close-x {
				width: 52px;
				height: 52px;
				display: flex;
				justify-content: center;
				align-items: center;
			}
		}

		.ant-modal-header {
			padding: 12px 50px 19px 24px;
			border: none;
			.ant-modal-title {
				text-align: left;
			}
		}

		.ant-modal-body {
			padding-top: 0;
		}
	}
`;

const AppModal = (props) => {
	return (
		<AppModalStyled
			closeIcon={<img src={iconClose} className='w-14px' />}
			{...props}
		></AppModalStyled>
	);
};
export default AppModal;
